import { useRef } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import classnames from 'classnames'
import Notification from './Notification'

interface NotificationItem {
  id?: string | number
  type?: string
  title?: string
  message?: string
  timeOut?: number
  progress?: number
  onClick?: () => void
}

interface NotificationsProps {
  notifications: NotificationItem[]
  onRequestHide?: (notification: NotificationItem) => void
  enterTimeout?: number
  leaveTimeout?: number
}

const Notifications: React.FC<NotificationsProps> = ({
  notifications,
  onRequestHide,
  enterTimeout = 400,
  leaveTimeout = 400
}) => {
  const nodeRef = useRef<HTMLDivElement>(null)

  const handleRequestHide = (notification: NotificationItem) => () => {
    if (onRequestHide) {
      onRequestHide(notification)
    }
  }

  const className = classnames('notification-container', {
    'notification-container-empty': notifications.length === 0
  })

  return (
    <div className={className}>
      <TransitionGroup>
        {notifications.map((notification) => {
          const key = notification.id || new Date().getTime()
          return (
            <CSSTransition
              nodeRef={nodeRef}
              key={key}
              classNames="notification"
              timeout={{ enter: enterTimeout, exit: leaveTimeout }}
            >
              <Notification
                type={notification.type}
                title={notification.title}
                message={notification.message}
                timeOut={notification.timeOut}
                progress={notification.progress}
                onClick={notification.onClick}
                onRequestHide={handleRequestHide(notification)}
              />
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </div>
  )
}

export default Notifications
